import React, { createContext, useContext, useState, useEffect } from 'react';

const DEFAULT_PREFERENCES = {
    voice: 'feminina',
    speed: 1.0,
    intonation: 1.0,
    fontSize: 'M',
    language: 'pt-BR',
};

const PreferencesContext = createContext();

export const PreferencesProvider = ({ children }) => {
    const [preferences, setPreferences] = useState(() => {
        try {
            const saved = localStorage.getItem('cgpt-preferences');
            if (saved) {
                const parsed = JSON.parse(saved);
                return { ...DEFAULT_PREFERENCES, ...parsed };
            }
        } catch (e) {
            console.error('Failed to parse preferences from localStorage:', e);
        }
        return DEFAULT_PREFERENCES;
    });

    useEffect(() => {
        try {
            localStorage.setItem('cgpt-preferences', JSON.stringify(preferences));
        } catch (e) {
            console.error('Failed to save preferences to localStorage:', e);
        }
    }, [preferences]);

    const updatePreferences = (newPrefs) => {
        setPreferences(prev => ({ ...prev, ...newPrefs }));
    };

    return (
        <PreferencesContext.Provider value={{ preferences, updatePreferences }}>
            {children}
        </PreferencesContext.Provider>
    );
};

export const usePreferences = () => {
    const context = useContext(PreferencesContext);
    if (context === undefined) {
        throw new Error('usePreferences must be used within a PreferencesProvider');
    }
    return context;
};
